import { useUser } from "src/common/context/userContextUtils.js";
import { useDevToolsUnlocked } from "src/features/sidebar/useDevToolsUnlock.js";
import { hasFeature } from "src/featureFlagUtils.js";

/** Rollout gate for Intelligence Layer — flip the `intelligenceLayer` feature flag to release it; until then only a super admin with dev-tools unlocked can preview it. */
export const useIntelligenceLayerVisible = () => {
	const { userIsSuperAdmin } = useUser();
	const devToolsUnlocked = useDevToolsUnlocked(userIsSuperAdmin());
	return hasFeature("intelligenceLayer") || devToolsUnlocked;
};
